import React from 'react';
import {Tabs} from 'antd-mobile';
import styles from './agent-tabs.module.scss';
import {useTranslation} from 'react-i18next';
import {cn} from '@/utils';

interface TabSelectorProps {
  activeTab: string;
  onChange: (tab: string) => void;
}

const TabSelector: React.FC<TabSelectorProps> = ({activeTab, onChange}) => {
  const {t} = useTranslation();
  const invitationArr = t('agent.tabs.invitationReward').split(' ');
  const invitationTitle = (
    <span className={styles.tabTitle}>
      {invitationArr.length > 1 ? (
        <>
          <span>{invitationArr[0]}</span>
          <br />
          <span>{invitationArr.slice(1).join(' ')}</span>
        </>
      ) : (
        <span>{invitationArr[0]}</span>
      )}
    </span>
  );
  return (
    <Tabs
      className={cn(styles.baseTabs, 'h-10 bg-white')}
      activeLineMode="full"
      activeKey={activeTab}
      onChange={onChange}>
      <Tabs.Tab title={t('agent.tabs.agent')} key="agent" />
      <Tabs.Tab title={invitationTitle} key="invitation-reward" />
      <Tabs.Tab title={t('agent.tabs.rules')} key="rules" />
    </Tabs>
  );
};

export default TabSelector;
